// VoK MUI base styles
import typography from "app/assets/theme/base/typography";
import colors from "app/assets/theme/base/colors";

// VoK MUI helper functions
import pxToRem from "app/assets/theme/functions/pxToRem";

const {size, fontWeightRegular} = typography;
const {grey, dark, secondary} = colors;

const stepLabel = {
    styleOverrides: {
        label: {
            marginTop: `${pxToRem(8)} !important`,
            fontWeight: fontWeightRegular,
            fontSize: size.md,
            color: grey[300],

            "&.Mui-active": {
                fontWeight: `${fontWeightRegular} !important`,
                color: `${dark.main} !important`,
            },

            "&.Mui-completed": {
                fontWeight: `${fontWeightRegular} !important`,
                color: `${secondary.main} !important`,
            },
        },
    },
};

export default stepLabel;
